import { Pipe, PipeTransform } from '@angular/core';
import { MessagingChannel } from 'sustainment-component';

@Pipe({
    name: 'filterCompanies',
    standalone: false
})
export class FilterCompaniesPipe implements PipeTransform {
  public transform(
    items: MessagingChannel[],
    expanded: boolean,
    selectedChannel?: string
  ): { channels: MessagingChannel[]; showMore: boolean } {
    const unread = items.filter((channel) => channel.isUnread);
    const read = items.filter((channel) => !channel.isUnread);

    read.sort((a, b) => b.lastMessageTimeStamp - a.lastMessageTimeStamp);

    if (expanded) {
      const allChannels = unread.concat(read);
      return { channels: allChannels, showMore: allChannels.length > 5 };
    }

    while (unread.length < 5 && read.length > 0) {
      const element = read.shift();
      if (element !== undefined) {
        unread.push(element);
      }
    }

    if (selectedChannel) {
      const isInUnread = unread.some(
        (channel) => channel.channel === selectedChannel
      );
      const selectedChannelObj = read.find(
        (channel) => channel.channel === selectedChannel
      );

      if (selectedChannelObj && !isInUnread) {
        unread.splice(5, 0, selectedChannelObj);
      }
    }

    return { channels: unread, showMore: !!read.length };
  }
}
